
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { StepItemProps } from ".";
import { loading, find } from "store/step";

interface ApiStepFindByIdInputProps {
    id: number;
}

type ApiStepFindOutputProps = OutputBaseProps<{ item: StepItemProps; }, ApiStepFindByIdInputProps>

export const apiStepFindById = async (data: ApiStepFindByIdInputProps, workflowId: number) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiStepFindOutputProps>(`/api/workflow/${workflowId}/step/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};
